import { observable, makeObservable } from 'mobx';
import BaseFilters from './helpers/BaseFilters';

export default class StoreExtensionResponseFilters extends BaseFilters {
    initialState = {
        skip: 0,
        limit: 25,
        sortBy: 'createdOn',
        sortDirection: 'DESC',
        search: ''
    };

    skip = this.initialState.skip;
    limit = this.initialState.limit;
    sortBy = this.initialState.sortBy;
    sortDirection = this.initialState.sortDirection;
    search = this.initialState.search;

    constructor() {
        super();

        makeObservable(this, {
            skip: observable,
            limit: observable,
            sortBy: observable,
            sortDirection: observable,
            search: observable
        });
    }
}
